export default __webpack_public_path__ + "static/media/logoLogin.7e2c2a15.svg";